import { render } from "./ui-radio.vue?vue&type=template&id=76dc017f&scoped=true"
import script from "./ui-radio.vue?vue&type=script&lang=js"
export * from "./ui-radio.vue?vue&type=script&lang=js"

import "./ui-radio.vue?vue&type=style&index=0&id=76dc017f&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76dc017f"]])

export default __exports__